import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "green-leftArrow",
  "use": "green-leftArrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"green-leftArrow\"><path d=\"M504.832 194.56 186.88 512l317.952 317.44L335.872 512z\" fill=\"#00FFBE\" /><path d=\"M504.832 194.56 335.872 512l168.96 317.44L335.872 512zM837.12 194.56 519.168 512 837.12 829.44 668.672 512z\" fill=\"#00FFBE\" /><path d=\"M837.12 194.56 668.672 512 837.12 829.44 668.672 512z\" fill=\"#00FFBE\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol